export default {
  acquisitions: [],
  invoices: [],
  new_invoice: [],
  invoice_items: [],
  acquisition_types: [],
  acquisition_sources: [],
  acquisition_categories: [],
  providers: [],
}
